export default __webpack_public_path__ + "menu-configure-icon.7ded1e128acca3a1ff57b452d1d50d51.svg";